import React from 'react';
import "./style.css";

function Headline({ title, description }) {
    return (
        <div className="office-header">
            <h3 className="office-title mb-0 hd">
                {title}
                <span className="underline large"></span>
                <span className="underline small"></span>
            </h3>
            <p className="office-description text-light text-sml mb-0">
                {description}
            </p>
        </div>
    );
}

export default Headline;
